import { theme } from '@styles/theme';

import type { IconProps } from './base';
import { BaseIcon } from './base';

export function IconCircleCheck(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <circle cx="12" cy="12" r="12" fill={theme.color.textPrimary} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.0178 7.2007C18.5381 7.684 18.5683 8.4974 18.085 9.0177L9.7279 18.0177C9.4764 18.2885 9.1207 18.4381 8.7513 18.4281C8.3819 18.4183 8.0346 18.2498 7.798 17.9659L4.5837 14.1088C4.1292 13.5634 4.2029 12.7526 4.7484 12.298C5.2939 11.8435 6.1046 11.9172 6.5592 12.4627L8.838 15.1971L16.2007 7.268C16.684 6.7476 17.4974 6.7175 18.0178 7.2007Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
